module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"keys":{"id":"ID da conta"}},"en-US":{"keys":{"id":"Account ID"}}}')
  delete Component.options._Ctor
}
